import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import UserFeedback from './UserFeedback';
import UserRequest from './UserRequest';
import UserReceived from './UserReceived';
import Profile from './Profile';
import { translate } from './translateFunction'; // Import the translate function
import UserFeatures from './UserFeatures'; // Import new UserFeatures component

const User = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  // State for translations
  const [translations, setTranslations] = useState({
    myFeedbacksTitle: '',
    feedbackOverviewDescription: '',
    veryPositive: '',
    positive: '',
    neutral: '',
    negative: '',
    veryNegative: '',
    showLegacy: ''
  });

  const [showLegacy, setShowLegacy] = useState(false); // State for "Legacy" toggle

  useEffect(() => {
    const loadTranslations = async () => {
      const myFeedbacksTitle = await translate(180);
      const feedbackOverviewDescription = await translate(181);
      const veryPositive = await translate(182);
      const positive = await translate(183);
      const neutral = await translate(184);
      const negative = await translate(185);
      const veryNegative = await translate(186);
      const showLegacy = await translate(434);

      setTranslations({
        myFeedbacksTitle,
        feedbackOverviewDescription,
        veryPositive,
        positive,
        neutral,
        negative,
        veryNegative,
        showLegacy
      });
    };

    loadTranslations();
  }, []); // Der Effekt wird nur einmal ausgeführt


  useEffect(() => {
    if (!user) {
      navigate('/login'); // Redirect unauthenticated users
    }
  }, [user, navigate]);

  const handleToggleLegacy = () => {
    setShowLegacy((prev) => !prev);
  };

  return (
    <div className="container-fluid mt-5">
      <section className="featured">
        <div className="content-wrapper banner">
          <div className="float-right">
            <img className="page-icon" src="/Content/themes/base/images/person_BOLD.svg" alt="User icon" />
          </div>
          <hgroup className="title">
            <h1>{translations.myFeedbacksTitle}</h1>
            <p>{translations.feedbackOverviewDescription}</p>
          </hgroup>
          <div className="feedback-legend">
            <div className="legend-item">
              <img className="evaluation-img" src="/Content/themes/base/images/VeryPositive.png" alt={translations.veryPositive} />
              <span>{translations.veryPositive}</span>
            </div>
            <div className="legend-item">
              <img className="evaluation-img" src="/Content/themes/base/images/Positive.png" alt={translations.positive} />
              <span>{translations.positive}</span>
            </div>
            <div className="legend-item">
              <img className="evaluation-img" src="/Content/themes/base/images/Unknown.png" alt={translations.neutral} />
              <span>{translations.neutral}</span>
            </div>
            <div className="legend-item">
              <img className="evaluation-img" src="/Content/themes/base/images/Negative.png" alt={translations.negative} />
              <span>{translations.negative}</span>
            </div>
            <div className="legend-item">
              <img className="evaluation-img" src="/Content/themes/base/images/VeryNegative.png" alt={translations.veryNegative} />
              <span>{translations.veryNegative}</span>
            </div>
          </div>
        </div>
      </section>
      <div className="container mt-5" id="flexcontainer" style={{paddingBottom: '150px'}}>
        <Profile />

        {/* Legacy Toggle */}
        <div className="legacy-toggle">
          <label htmlFor="legacyToggle"
          style={{ fontStyle: 'italic', fontSize: 'small', fontWeight: 'unset' }}>
            {translations.showLegacy}
            <input
              type="checkbox"
              id="legacyToggle"
              checked={showLegacy}
              onChange={handleToggleLegacy}
              style={{ marginLeft: '10px' }}
            />
          </label>
        </div>

        {/* <UserReceived /> */}
        <UserReceived showLegacy={showLegacy} />

        <UserFeedback />

        <UserRequest />

        <UserFeatures />
      </div>
    </div>
  );
};

export default User;
